module.exports = __webpack_public_path__ + "static/img/cooperation_3.fa7f019.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/cooperation_3.png
// module id = 95WP
// module chunks = 1